import { useCallback as t } from "react";
import { useEventResolver as s } from "@biron-data/react-contexts";
const u = (r, e) => {
  const o = s();
  return t(
    () => r ? (o.capture({
      category: "metrics",
      action: "copy_metric"
    }), e(r)) : null,
    [r, e, o]
  );
};
export {
  u as useHandleAddMetricFromClipboard
};
//# sourceMappingURL=useHandleAddMetricFromClipboard.js.map
